import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-errorpage',
  templateUrl: './errorpage.component.html',
  styleUrls: ['./errorpage.component.scss']
})
export class ErrorpageComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit(): void {
  }
  
  backClicked() {
    this.location.back();
  }

}
